module.exports = __webpack_public_path__ + "img/main_header_bgimg2.72d97142.jpg";